module.exports = __webpack_public_path__ + "prod/1.42.2/img/obj_insurance2x.bc346ee1.png";